import { createBindingApi2 } from '../../api/create-binding-v2';
import { ApiHost, BindCardOptionsV2, PaymentFrameEventsV2 } from '../../types';
import { paymentForm } from '../payment-form';

export const bindCardV2 = async (apiHost: ApiHost, options: BindCardOptionsV2) => {
    const url = await createBindingApi2(apiHost, options);

    return paymentForm<PaymentFrameEventsV2>(apiHost, { url });
};
